module.exports = __webpack_public_path__ + "static/media/22.d6d0c3c5.png";